import {combineReducers} from 'redux';

/* MAIN */
import {mainAuthReducer} from './main/mainAuthReducer';
import {mainNoticeReducer} from './main/mainNoticeReducer';
import {mainBetaReducer} from './main/mainBetaReducer';
import {mainCommunityReducer} from './main/mainCommunityReducer';
import {mainFaqReducer} from './main/mainFaqReducer';
import {mainPolicyReducer} from './main/mainPolicyReducer';
import {mainProfilesReducer} from './main/mainProfilesReducer';
import {mainOpinionReducer} from './main/mainOpinionReducer';

export const rootReducer = combineReducers({
  mainAuthReducer,
  mainNoticeReducer,
  mainBetaReducer,
  mainCommunityReducer,
  mainFaqReducer,
  mainPolicyReducer,
  mainProfilesReducer,
  mainOpinionReducer
});
